import { Component, OnInit, ChangeDetectorRef, Inject, PLATFORM_ID } from '@angular/core';
import { RouterExtService } from './common/services/router-ext.service';
import { RsbLookupModel } from './common/model/rsb-lookup.model';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { RsbService } from './service/rsb.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'rsb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  openModalSubscription!: Subscription;
  routerSubscription!: Subscription;
  loading: boolean = false;
  hideFooter: boolean = false;
  hideMainSidebar: boolean = false;
  hideSidebar: boolean = false;
  hidePropertyBar: boolean = false;
  hideAllSidebars: boolean = false;
  hideFooterMob: boolean = false;
  hide: boolean = false;
  isMobileLayout: boolean = false;
  showLogoutModal = false;
  constructor(
    private routerExtService: RouterExtService,
    private lookupModel: RsbLookupModel,
    private router: Router,
    private rsbService: RsbService,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    this.lookupModel.isBrowser = isPlatformBrowser(platformId);
    this.routerSubscription = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.hideMainSidebar = val.url.indexOf('/addCompany') !== -1 ? true : false;
        this.hideSidebar = val.url.indexOf('/addProject') !== -1 ? true : false;
        this.hidePropertyBar = val.url.indexOf('/post-property') !== -1 ? true : false;
        this.hideAllSidebars = val.url.indexOf('/login') !== -1 ? true : false;
      }
    })
  }



  ngOnInit() {
  }




}
